import styled from "styled-components";

export const SearchBarWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;